import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { langs, chosen_lang, show_header, w_labels, _online, _hasorglogo, _orglogo } from '../RecoilState';
import { Button, Popover } from 'antd';
import SmallLangButton from './SmallLangButton';
import { BarsOutlined, DisconnectOutlined, WifiOutlined } from '@ant-design/icons';
import Text from './Text';
import axios from 'axios';
import './Header.css'

const Header = () => {

    const [languages, setLanguages] = useRecoilState(langs);
    const [c_lang, setCLang] = useRecoilState(chosen_lang);
    const [labels, setLabels] = useRecoilState(w_labels);
    const [showheader, setShowheader] = useRecoilState(show_header);
    const [isonline, setIsonline] = useRecoilState(_online);
    const [open, setOpen] = useState(false);
    const [serveronline, setServeronline] = useState(false);
    const [orglogo, setOrglogo] = useRecoilState(_orglogo);
    const [hasorglogo, setHasorglogo] = useRecoilState(_hasorglogo);

    // console.log(c_lang);
    // console.log(languages);

    // useEffect(() => { console.log(open) }, [open])

    useEffect(() => {
        axios.get('heartbeat')
            .then((response) => {
                // console.log(response.data);
                if (response.data.status === "OK") {
                    setServeronline(true);
                }
                else {
                    setServeronline(false);
                }
            })
            .catch((err) => {
                console.log(err);
                setServeronline(false);
            });
    }, [])

    const hide = () => {
        // console.log("lang clicked")
        setOpen(false);
    }

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    const content = () => {
        return (
            <>
                <div className="mb-3 border-b border-black">
                    <Text style={"text-small text-bold"} value={labels[1]} />
                </div>
                {/* <a onClick={hide}>Close</a> */}
                {
                    languages.map((value, i) => {
                        // console.log(value);
                        return (
                            <>
                                <button onClick={hide}>
                                    <SmallLangButton details={value} />
                                </button>
                            </>
                        )
                    })
                }
            </>
        )
    };

    return (
        <>

            <div className="header justify-between items-center">
                <div className='flex flex-row gap-2'>
                    <img src={require('../assets/mpoweru_logo.png')} width={65} alt="loading..." />
                    {/* client logo for customization. leave disable for SAAS */}
                    {/* <img src={require('../assets/crisil_logo.png')} width={60} alt="loading..." /> */}
                    <>
                        {
                            hasorglogo ?
                                <img src={orglogo.logo_small} width={50} alt="client logo" />
                                : null
                        }
                    </>
                </div>
                <div className='flex flex-col items-center'>
                    <div>
                        {
                            serveronline ?
                                <div className='flex flex-row'>
                                    <div className="green-dot-round mt-[8px] mr-[4px]"></div>
                                    {/* <p className='text-[13px]'>Server Online</p> */}
                                    <Text style={"text-xtra-small"} value={labels[70]} />
                                </div>
                                :
                                <div className='flex flex-row'>
                                    <div className="red-dot-round mt-[10px] mr-[4px]"></div>
                                    {/* <p className='text-[14px]'>Server Offline</p> */}
                                    <Text style={"text-xtra-small"} value={labels[71]} />
                                </div>
                        }
                    </div>
                    <div>
                        {
                            isonline ?
                                <div className="flex">
                                    <div className="flex-row gap-0 mt-[-4px]">
                                        {/* <WifiOutlined /> */}
                                        <div className="green-dot-round mt-[10px] mr-[4px]"></div>
                                    </div>
                                    <div>
                                        <Text style={"text-xtra-small"} value={labels[38]} />
                                    </div>
                                </div>
                                :
                                <div className="flex">
                                    <div className="flex-row gap-0 mt-[-4px]">
                                        {/* <DisconnectOutlined /> */}
                                        <div className="red-dot-round mt-[10px] mr-[4px]"></div>
                                    </div>
                                    <div>
                                        <Text style={"text-xtra-small"} value={labels[39]} />
                                    </div>
                                </div>
                        }
                    </div>
                </div>

                {
                    showheader ?
                        <>
                            <Popover
                                content={content}
                                // open={open}
                                // onOpenChange={handleOpenChange}
                                trigger="click"
                            >
                                <div className="pop-container">
                                    <Button block={true} className="px-5">
                                        {
                                            <div className="flex gap-4 justify-between content-center">
                                                <p className="text-small">{c_lang.language}</p>
                                                {
                                                    <BarsOutlined style={{ fontSize: '20px', color: 'var(--color-brand)' }} />
                                                }
                                            </div>

                                        }
                                    </Button>
                                </div>
                            </Popover>
                        </>
                        : null
                }
            </div>
        </>
    )
}

export default Header